import { createStore } from 'vuex';
import user from './User';
import mobileModule from './MobileModule';
import utm from './Utm';
import modals from './Modals';

export default createStore({
  modules: {
    user,
    mobileModule,
    utm,
    modals,
  },
});
